
import Vue from "vue"
import OrderForm from "@/components/OrderForm.vue"

export default Vue.extend({
    components: {
        OrderForm
    },
    created() {
        document.title = this.$vuetify.lang.t("$vuetify.tab_titles.order_create")
    }
})
